/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import './spectral-scan.scss';

import 'javascript-detect-element-resize/detect-element-resize';
import $ from 'jquery';

const NUMBER_OF_POWER_BINS = 101;
const NUMBER_OF_SAMPLES = 4096;

/* eslint-disable angular/angularelement */
/*@ngInject*/
export default function SpectralScanController($rootScope, $q, $document, $scope, $mdDialog, $timeout, $mdUtil, $translate,
                                                   toast, types, gatewayCommandService, importExport, gatewayId) {

    var vm = this;

    vm.$onInit = function () {
        vm.gatewayId = gatewayId;
        vm.types = types;

        vm.spectralScan = {
            samplePeriod: 0,
            num125kChan: 0,
            startFreq125k: 800000,
            stepFreq125k: 125,
            num500kChan: 0,
            startFreq500k: 800000,
            stepFreq500k: 500
        };

        vm.antenna = types.spectralScanAntenna.antenna0.value;
        vm.samplePeriod = (vm.spectralScan.samplePeriod + 1) * 0.5;
        vm.minRx = 800000;
        vm.maxRx = 950000;


        vm.spectralScanExecuting = false;
        vm.spectralScanTimeout = null;
        vm.spectralScanProgress = 0;
        vm.spectralScanResults = null;
        vm.spectralScanNotSupported = false;

        vm.channelListItems = [];

        var font = {
            color: "#545454",
            size: 10,
            family: "Roboto"
        };

        vm.plotOptions = {
            title: null,
            subtitle: null,
            shadowSize: 4,
            HtmlText: false,
            grid: {
                hoverable: false,
                borderWidth: 2,
                color: "#DDDDDD",
                tickColor: "#DDDDDD"
            },
            legend: {
                show: false
            },
            xaxis: {
                font: angular.copy(font),
                labelFont: {family: font.family, color: font.color, size: font.size + 2, weight: 'bold'}
            },
            yaxis: {
                font: angular.copy(font),
                labelFont: {family: font.family, color: font.color, size: font.size + 2, weight: 'bold'}
            },
            colors: [],
            series: {
                lines: {
                    show: false,
                    fill: false,
                    steps: false
                },
                bars: {
                    show: false,
                    lineWidth: 0,
                    fill: 0.9,
                    barWidth: 0.35
                }
            }
        };

        vm.plotData = {
            'spectralScan': null
        };

        vm.currentPlotDataKey = 'spectralScan';

        vm.plotMinimum = -140;
        vm.plotMaximum = 0;

        vm.plot = null;
        vm.showPlot = false;

        vm.antennasCount = 2;

        vm.samplePeriodChanged = function () {
            vm.spectralScan.samplePeriod = Math.floor(vm.samplePeriod / 0.5) - 1;
        };

        vm.plotMinMaxChanged = function () {
            if (vm.selectedChannelIndex < 2 && vm.showPlot) {
                updatePlotYMinMax();
                updatePlot();
            }
        };

        vm.channelIndexChanged = function () {
            plotSpectralScan();
        };

        vm.spectralScanAntenna = function (antennasCount) {
            var antennas = {};
            for (var i = 0; i < antennasCount; i++) {
                var antennaName = "antenna" + i;
                antennas[antennaName] = vm.types.spectralScanAntenna[antennaName];
            }
            return antennas;
        };

        vm.startSpectralScan = startSpectralScan;
        vm.stopSpectralScan = stopSpectralScan;
        vm.exportToCsv = exportToCsv;
        vm.importFromCsv = importFromCsv;

        vm.close = close;

        vm.loading = function () {
            return $rootScope.loading;
        };

        loadSpectralScanParams();
    };

    function close() {
        if (vm.showPlot) {
            var parent = angular.element('#tk-spectral-scan-dialog', $document);
            removeResizeListener(parent[0], updatePlot); //eslint-disable-line
        }
        stopSpectralScan();
        $mdDialog.cancel();
    }

    function loadSpectralScanParams() {

        gatewayCommandService.executeCommand(vm.gatewayId.id,
            types.gatewayCommand.getAntennasCount.value, {}, true).then(
            (params) => {
                if (params.error) {
                    if (angular.equals(params.error, types.gatewayCommandNotSupported.value)) {
                        // ignore
                    } else {
                        onError(params.error);
                    }
                } else {
                    vm.antennasCount = params.antennasCount;
                }
            },
            (rejection) => {
                onError(rejection.data);
            }
        );

        gatewayCommandService.executeCommand(vm.gatewayId.id,
            types.gatewayCommand.getAntennasCount.value, {}, true).then(
            (params) => {
                if (params.error) {
                    if (!angular.equals(params.error, types.gatewayCommandNotSupported.value)) {
                        onError(params.error);
                    }
                } else {
                    vm.antennasCount = params.antennasCount;
                }
            },
            (rejection) => {
                onError(rejection.data);
            }
        );

        gatewayCommandService.executeCommand(vm.gatewayId.id,
            types.spectralScanCommand.getSpectralScanParams.value, {}, true).then(
            (params) => {
                if (params.error) {
                    vm.spectralScanNotSupported = true;
                    if (angular.equals(params.error, types.gatewayCommandNotSupported.value)) {
                        onError($translate.instant("gateway-command.not-supported"));
                    } else {
                        onError(params.error);
                    }
                } else {
                    vm.spectralScan = params;
                    vm.samplePeriod = (vm.spectralScan.samplePeriod + 1) * 0.5;
                    vm.antenna = vm.spectralScan.antenna == 0 ? types.spectralScanAntenna.antenna0.value : types.spectralScanAntenna.antenna1.value;

                    if (angular.isDefined(vm.spectralScan.minRx)) {
                        vm.minRx = Math.round(vm.spectralScan.minRx / 100000)*100;
                    }

                    if (angular.isDefined(vm.spectralScan.maxRx)) {
                        vm.maxRx = Math.round(vm.spectralScan.maxRx / 100000)*100;
                    }
                }
            },
            (rejection) => {
                onError(rejection.data);
            }
        );
    }

    function startSpectralScan() {
        vm.spectralScanExecuting = true;
        vm.spectralScanProgress = 0;

        vm.spectralScan.antenna = vm.antenna == types.spectralScanAntenna.antenna0.value ? 0 : 1;

        gatewayCommandService.executeCommand(vm.gatewayId.id,
            types.spectralScanCommand.executeSpectralScan.value, vm.spectralScan, true).then(
            () => {
                getSpectralScanProgress();
            },
            (rejection) => {
                onError(rejection.data);
            }
        );
    }

    function stopSpectralScan() {
        vm.spectralScanExecuting = false;
        vm.spectralScanProgress = 0;
        if (vm.spectralScanTimeout) {
            $timeout.cancel(vm.spectralScanTimeout);
            vm.spectralScanTimeout = null;
        }
    }

    function getSpectralScanProgress() {
        vm.spectralScanTimeout = $timeout(() => {
            gatewayCommandService.executeCommand(vm.gatewayId.id,
                types.spectralScanCommand.getSpectralScanProgress.value, {}, true).then(
                (data) => {
                    if (!vm.spectralScanExecuting) {
                        return;
                    }
                    if (data && angular.isDefined(data.progress)) {
                        vm.spectralScanProgress = data.progress;
                        if (vm.spectralScanProgress >= 100) {
                            getSpectralScanResults();
                        } else {
                            getSpectralScanProgress();
                        }
                    } else {
                        onError('Invalid Spectral Scan Progress Response!');
                    }
                },
                (rejection) => {
                    onError(rejection.data);
                }
            );
        }, 1000);
    }

    function getSpectralScanResults() {
        gatewayCommandService.executeCommand(vm.gatewayId.id,
            types.spectralScanCommand.getSpectralScanResults.value, {}, true).then(
            (data) => {
                vm.spectralScanExecuting = false;
                vm.spectralScanProgress = 0;
                processSpectralScanResults(data, vm.spectralScan);
            },
            (rejection) => {
                onError(rejection.data);
            }
        );
    }

    function processSpectralScanResults(data, params) {
        vm.spectralScanResults = data;
        vm.spectralScanResults.params = angular.copy(params);
        vm.channelListItems.length = 0;
        vm.channelListItems.push(
            {
                name: $translate.instant('spectrum-analyzer.power-over-frequency', {percents: '50%'}),
                index: 0
            }
        );
        vm.channelListItems.push(
            {
                name: $translate.instant('spectrum-analyzer.power-over-frequency', {percents: '80%'}),
                index: 1
            }
        );
        var channelCount = vm.spectralScanResults.channelPowerBins.length / NUMBER_OF_POWER_BINS;

        var prefix;
        var freq;

        for (var i=0; i<channelCount; i++) {
            if (i<params.num125kChan) {
                prefix = '125k';
                freq = params.startFreq125k + params.stepFreq125k*i;
            } else {
                prefix = '500k';
                freq = params.startFreq500k + params.stepFreq500k*(i-params.num125kChan);
            }
            vm.channelListItems.push(
                {
                    name: $translate.instant('spectrum-analyzer.channel-list-item', {prefix: prefix, index: i, frequency: freq}),
                    index: i+2
                }
            );
        }

        vm.selectedChannelIndex = 0;
        plotSpectralScan();
    }

    function plotSpectralScan() {

        var dbfs2dbm = vm.spectralScanResults.dbm2dbfsOffset;
        var params = vm.spectralScanResults.params;
        var channelPowerBins = vm.spectralScanResults.channelPowerBins;

        if (vm.selectedChannelIndex < 2) {
            var spectralScanPowerVsFreqSeries = [{label: vm.channelListItems[vm.selectedChannelIndex].name, data: []}];

            var freqStart = params.startFreq125k;
            var freqStep = params.stepFreq125k;
            var count, idx, min = NUMBER_OF_SAMPLES, max = 0;
            var requiredCount = vm.selectedChannelIndex == 0 ? NUMBER_OF_SAMPLES*0.5 : NUMBER_OF_SAMPLES*0.8;
            for (var channelIndex = 0; channelIndex< params.num125kChan; channelIndex++) {
                count = 0;
                idx = 0;
                for (idx=NUMBER_OF_POWER_BINS-1; idx && count < requiredCount; idx--) {
                    count += channelPowerBins[channelIndex * NUMBER_OF_POWER_BINS + idx];
                }
                if (min > idx)
                    min = idx;
                if (max < idx)
                    max = idx;

                spectralScanPowerVsFreqSeries[0].data.push([(freqStart+channelIndex*freqStep)/1000.0,-(idx+dbfs2dbm)]);
            }

            vm.calculatedSamplesMin = min;

            vm.plotData['spectralScan'] = spectralScanPowerVsFreqSeries;

            vm.plotOptions.series.lines.show = true;
            vm.plotOptions.series.bars.show = false;

            vm.plotOptions.colors = ['rgb(33, 150, 243)'];
            vm.plotOptions.xaxis.label = $translate.instant('spectrum-analyzer.spectrum-plot-frequency-title');
            vm.plotOptions.xaxis.min = freqStart/1000.0;
            vm.plotOptions.xaxis.max = (freqStart + (params.num125kChan-1)*freqStep)/1000.0;
            vm.plotOptions.xaxis.tickFormatter = tickFormatter;
            vm.plotOptions.xaxis.ticks = ticksFunction;

            vm.plotOptions.yaxis.tickFormatter = tickFormatter;
            vm.plotOptions.yaxis.ticks = ticksFunction;
            vm.plotOptions.yaxis.label = $translate.instant('spectrum-analyzer.spectrum-plot-power-title');
            updatePlotYMinMax();
        } else {

            var spectralScanBinnedPowers = [{label: vm.channelListItems[vm.selectedChannelIndex].name, data: []}];

            channelIndex = vm.selectedChannelIndex-2;
            max = 0;
            for (var j=NUMBER_OF_POWER_BINS;j;j--) {
                count = channelPowerBins[channelIndex * NUMBER_OF_POWER_BINS + j-1];
                max = Math.max(max, count);
                spectralScanBinnedPowers[0].data.push([-(dbfs2dbm+j-1),count]);
            }

            vm.plotData['spectralScan'] = spectralScanBinnedPowers;

            vm.plotOptions.series.lines.show = false;
            vm.plotOptions.series.bars.show = true;

            vm.plotOptions.colors = ['rgb(33, 150, 243)'];
            vm.plotOptions.xaxis.label = $translate.instant('spectrum-analyzer.spectrum-flot-power-bins-title');
            vm.plotOptions.xaxis.min = -(dbfs2dbm+100);
            vm.plotOptions.xaxis.max = -dbfs2dbm;
            vm.plotOptions.xaxis.tickFormatter = tickFormatter;
            vm.plotOptions.xaxis.ticks = powerBinsTicksFunction;

            vm.plotOptions.yaxis.label = $translate.instant('spectrum-analyzer.spectrum-flot-count-title');
            vm.plotOptions.yaxis.min = 0;
            vm.plotOptions.yaxis.max = max;
            vm.plotOptions.yaxis.tickFormatter = tickFormatter;
            vm.plotOptions.yaxis.ticks = ticksFunction;
            vm.plotMinimum = -140;
            vm.plotMaximum = 0;
        }
        updatePlot();
    }

    function updatePlotYMinMax() {
        var dbfs2dbm = vm.spectralScanResults.dbm2dbfsOffset;
        if (vm.plotMaximum && vm.plotMaximum > vm.plotMinimum) {
            vm.plotOptions.yaxis.min = vm.plotMinimum;
            vm.plotOptions.yaxis.max = vm.plotMaximum;
        } else {
            if (vm.calculatedSamplesMin > 60) {
                vm.plotOptions.yaxis.min = -(100 + dbfs2dbm);
                vm.plotOptions.yaxis.max = -(60 + dbfs2dbm);
                vm.plotMinimum = vm.plotOptions.yaxis.min;
                vm.plotMaximum = vm.plotOptions.yaxis.max;
            } else {
                var val = vm.calculatedSamplesMin + dbfs2dbm - 3;
                vm.plotOptions.yaxis.min = -(100+dbfs2dbm);
                vm.plotOptions.yaxis.max = -(val);
                vm.plotMinimum =  vm.plotOptions.yaxis.min;
                vm.plotMaximum = vm.plotOptions.yaxis.max;
            }
        }
    }

    function tickFormatter(value) {
        return value.toFixed(1);
    }

    function ticksFunction(axis) {
        var step = (axis.max - axis.min) / 4;
        var ticks = [];
        for (var i=0;i<5;i++) {
            ticks.push(axis.min + step * i);
        }
        return ticks;
    }

    function powerBinsTicksFunction(axis) {
        var step = (axis.max - axis.min) / 10;
        var ticks = [];
        for (var i=0;i<11;i++) {
            ticks.push(axis.min + step * i);
        }
        return ticks;
    }

    function exportToCsv() {
        var dbfs2dbm = vm.spectralScanResults.dbm2dbfsOffset;
        var params = vm.spectralScanResults.params;
        var channelPowerBins = vm.spectralScanResults.channelPowerBins;

        var csvData = '';
        var idx;
        var frequencykHz = params.startFreq125k;
        var outputLine;
        for (idx = 0; idx < params.num125kChan; idx++) {
            outputLine = '';
            outputLine += `${frequencykHz * 1000}`;
            for (var j = NUMBER_OF_POWER_BINS; j ; j--) {
                outputLine += `,-${j + dbfs2dbm-1},${channelPowerBins[idx*NUMBER_OF_POWER_BINS+j-1]}`;
            }
            outputLine += '\n';
            csvData += outputLine;
            frequencykHz += params.stepFreq125k;
        }
        frequencykHz = params.startFreq500k;
        for (; idx < (params.num125kChan + params.num500kChan); idx++) {
            outputLine = '';
            outputLine += `${frequencykHz * 1000}`;
            for (j = NUMBER_OF_POWER_BINS; j ; j--) {
                outputLine += `,-${j + dbfs2dbm-1},${channelPowerBins[idx*NUMBER_OF_POWER_BINS+j-1]}`;
            }
            outputLine += '\n';
            csvData += outputLine;
            frequencykHz += params.stepFreq500k;
        }
        importExport.downloadFile(csvData, 'spectral-scan', types.fileType.CSV);
    }

    function importFromCsv($event) {
        importExport.uploadFile($event, [types.fileType.CSV],
            'spectrum-analyzer.import-spectral-scan-results', 'spectrum-analyzer.spectral-scan-results-file').then(
            (csvData) => {

                var tempStr, tempStrList;

                var lineCount=0,
                currentFrequency=0,
                previousFrequency=0,
                startFreq = 0,
                startFreq125 = 0,
                startFreq500 = 0,
                num125kChannels = 0,
                num500kChannels = 0,
                processing125k = true,
                freqStep125k = 0,
                freqStep500k = 0,
                freqStep=0;

                var lines = csvData.split(/\r?\n/);
                for (var l=0;l<lines.length;l++) {
                    tempStr = lines[l];
                    if (!tempStr.length) {
                        break;
                    }
                    tempStrList = tempStr.split(',');
                    currentFrequency = Number(tempStrList[0])/1000;
                    if (lineCount == 0) {
                        startFreq = currentFrequency;
                    } else if (lineCount == 1) {
                        freqStep = currentFrequency - previousFrequency;
                        if (freqStep < 500) {
                            startFreq125 = startFreq;
                            freqStep125k = freqStep;
                        }
                        else {
                            startFreq500 = startFreq;
                            freqStep500k = freqStep;
                            processing125k = false;
                        }
                    } else {
                        if (previousFrequency > currentFrequency) {
                            startFreq500 = currentFrequency;
                            processing125k = false;
                        }
                        if (num500kChannels == 1) {
                            freqStep500k = currentFrequency - previousFrequency;
                        }
                    }
                    previousFrequency = currentFrequency;
                    if (processing125k) num125kChannels++;
                    else num500kChannels++;

                    lineCount++;
                }

                vm.spectralScan.num125kChan = num125kChannels;
                vm.spectralScan.startFreq125k = startFreq125;
                vm.spectralScan.stepFreq125k = freqStep125k;
                vm.spectralScan.num500kChan = num500kChannels;
                vm.spectralScan.startFreq500k = startFreq500;
                vm.spectralScan.stepFreq500k = freqStep500k;

                var spectralScanResults = {
                    channelPowerBins: []
                };

                var channel = 0;

                for (l=0;l<lines.length;l++) {
                    tempStr = lines[l];
                    if (!tempStr.length) {
                        break;
                    }
                    tempStrList = tempStr.split(',');
                    var listIndex = 0;
                    for (var i = NUMBER_OF_POWER_BINS; i; i--) {
                        listIndex+=2;
                        spectralScanResults.channelPowerBins[channel*NUMBER_OF_POWER_BINS + i-1] = Number(tempStrList[listIndex]);
                    }
                    if (channel==0) {
                        spectralScanResults.dbm2dbfsOffset = -Number(tempStrList[tempStrList.length-2]);
                    }
                    channel++;
                }
                processSpectralScanResults(spectralScanResults, vm.spectralScan);
            },
            function fileSelectCanceled() {
            });
    }

    function onError(error) {
        vm.spectralScanExecuting = false;
        vm.spectralScanProgress = 0;
        var toastParent = angular.element('#tk-spectral-scan-dialog', $document);
        var dialogContent = toastParent.find('md-dialog-content');
        if (dialogContent.length > 0) {
            toastParent = dialogContent;
        }
        toast.showError(error, toastParent, 'bottom right');
    }

    function updatePlot() {
        if (!vm.currentPlotDataKey || !vm.plotData[vm.currentPlotDataKey]) {
            return;
        }
        if (vm.showPlot) {
            vm.plot = $.plot(vm.spectralFlotElement, vm.plotData[vm.currentPlotDataKey], vm.plotOptions);
        } else {
            var parent = angular.element('#tk-spectral-scan-dialog', $document);
            vm.spectralFlotElement = parent.find('#spectral-flot');
            vm.showPlot = true;
            addResizeListener(parent[0], updatePlot); //eslint-disable-line
            $mdUtil.nextTick(() => {
                vm.plot = $.plot(vm.spectralFlotElement, vm.plotData[vm.currentPlotDataKey], vm.plotOptions);
            });
        }
    }

}
/* eslint-enable angular/angularelement */


// WEBPACK FOOTER //
// ./src/app/gateway/spectral-scan/spectral-scan.controller.js